/**
 * b4b-variant-image-fix.js — Koröshi (v2)
 * ------------------------------------------------------------------
 * Las cards duplicadas por b4b (variable-products) llegan con la
 * imagen del producto PADRE; el swap de b4b en cliente no procesa
 * todas las cards. Este parche asigna la featured_image de cada
 * variante leyendo /products/{handle}.js.
 *
 * v2: b4b monta/anota sus cards DESPUÉS de DOMContentLoaded, así que
 * ejecutamos con reintentos escalonados y un observer que también
 * vigila cambios de atributos (href), no solo inserción de nodos.
 * Todo el proceso es idempotente: re-ejecutar no tiene efectos.
 */
(function () {
  'use strict';

  var productCache = new Map();
  var routesRoot =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function normalizeUrl(u) {
    if (!u) return u;
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  // Token de color: 2611CC43_000003_1.jpg -> "000003"
  function colorToken(src) {
    var m = (src || '').match(/_([0-9A-Za-z]{6})_\d+\.[a-z]+/i);
    return m ? m[1] : null;
  }

  // Sufijo de vista: 2611CC43_000003_8.jpg -> "8"
  function viewSuffix(src) {
    var m = (src || '').match(/_(\d+)\.[a-z]+(\?|$)/i);
    return m ? m[1] : null;
  }

  function buildSrcset(newUrl, referenceSrcset) {
    var widths = (referenceSrcset || '')
      .split(',')
      .map(function (s) {
        var m = s.trim().match(/\s(\d+)w$/);
        return m ? m[1] : null;
      })
      .filter(Boolean);
    if (!widths.length) return null;
    var base = newUrl.split('?')[0];
    return widths
      .map(function (w) {
        return base + '?width=' + w + ' ' + w + 'w';
      })
      .join(', ');
  }

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(routesRoot + 'products/' + handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          })
      );
    }
    return productCache.get(handle);
  }

  function rewriteImg(img, newUrl) {
    newUrl = normalizeUrl(newUrl);
    var refSrcset =
      img.getAttribute('data-offline-srcset') || img.getAttribute('srcset') || '';
    var newSrcset = buildSrcset(newUrl, refSrcset);

    img.setAttribute('data-offline-src', newUrl);
    if (newSrcset) img.setAttribute('data-offline-srcset', newSrcset);

    var currentSrc = img.getAttribute('src') || '';
    if (currentSrc.indexOf('data:image') === 0 && !img.getAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
    }
    img.setAttribute('src', newUrl);
    if (newSrcset) img.setAttribute('srcset', newSrcset);
  }

  function fixCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var url;
    try {
      url = new URL(link.href, location.origin);
    } catch (e) {
      return;
    }

    var variantId = url.searchParams.get('variant');
    if (!variantId) return; // card normal, no duplicada por b4b

    var handle = (url.pathname.split('/products/')[1] || '').split('/')[0];
    if (!handle) return;

    getProduct(handle).then(function (product) {
      if (!product || !product.variants) return;

      var variant = product.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      var featured =
        variant && variant.featured_image && variant.featured_image.src;
      if (!featured) return;

      featured = normalizeUrl(featured);
      var token = colorToken(featured);
      var sameColorImages = token
        ? (product.images || []).map(normalizeUrl).filter(function (u) {
            return colorToken(u) === token;
          })
        : [];

      card.querySelectorAll('img').forEach(function (img) {
        var current =
          (img.getAttribute('src') || '').indexOf('data:image') === 0
            ? img.getAttribute('data-offline-src') || ''
            : img.getAttribute('src') || '';

        // Idempotencia: si ya muestra el color correcto, no tocar
        if (token && colorToken(current) === token) return;

        var view = viewSuffix(current);
        var target =
          (view &&
            sameColorImages.find(function (u) {
              return viewSuffix(u) === view;
            })) ||
          featured;

        rewriteImg(img, target);
      });
    });
  }

  function run() {
    document.querySelectorAll('product-card').forEach(fixCard);
  }

  var debounceTimer;
  function debouncedRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 250);
  }

  function init() {
    run();

    // Reintentos escalonados: b4b termina de montar sus cards tarde
    [800, 2000, 4000, 7000].forEach(function (ms) {
      setTimeout(run, ms);
    });

    window.addEventListener('load', function () {
      run();
      setTimeout(run, 1500);
    });

    var scope = document.querySelector('main') || document.body;
    new MutationObserver(debouncedRun).observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
